import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { downloadParam, downloadReport } from "@tKgpco/Services/ReportsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";

type PdfParameterParam = HasOnSuccess & downloadParam & HasOnError;

type HandlerType = CustomApiHandler<PdfParameterParam, Blob>;

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = (await downloadReport(props.parameter)) as unknown as Blob;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult) {
        const url = window.URL.createObjectURL(props.apiResult);
        const a = document.createElement("a");
        a.href = url;
        a.download = props.parameter.downloadFileName;
        document.body.appendChild(a);
        a.click();

        // Clean up
        a.remove();
        window.URL.revokeObjectURL(url);

        if (props.parameter?.onSuccess) {
            props.parameter.onSuccess();
        }
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult) {
        if (props.parameter?.onError) {
            props.parameter.onError();
        }
    }
};

export const chain = [RequestDataFromApi, ExecuteOnSuccessCallback, ExecuteOnErrorCallback];

export const downloadReportHistory = createHandlerChainRunner(chain, "downloadReportHistory");
export default downloadReportHistory;
